/**
  商品分类树
  GET /baseinfo/category/tree
  接口ID：219275132
  接口地址：https://app.apifotwitter.com/link/project/4556737/apis/api-219275132
 */

import { get } from "../utils/fetch";

/**
 * AuthResult
 */

export var apiBaseinfoProductCategoryTree = function apiBaseinfoProductCategoryTree() {
  return get({
    url: '/baseinfo/category/tree'
  });
};